import ace from 'ace-builds';
const Range = ace.require('ace/range').Range;
export class EditorLineHighlight {
    constructor(editor, cssClass) {
        this.editor = editor;
        this.cssClass = cssClass;
    }
    setLine(line) {
        if (line === this.currentLine) {
            return;
        }
        if (this.currentRange !== undefined) {
            this.editor.session.removeMarker(this.currentRange);
            this.currentRange = undefined;
        }
        this.currentLine = line;
        if (line !== undefined) {
            this.currentRange = this.editor.session.addMarker(new Range(line - 1, 0, line, 0), 'hilight-line ' + this.cssClass, 'screenLine');
        }
    }
    clear() {
        this.setLine(undefined);
    }
}
